module.exports = __webpack_public_path__ + "img/jomiremop.9ffb6839.png";